function configure(Highcharts) {
    Highcharts.setOptions({
        chart: {
            style: {
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px"
            }
        },
        title: {
            style: {
                fontSize: "16px"
            }
        }
    });
}
export default configure;
